import { FC } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { Environment } from 'relay-runtime';
import { CustomsMessagingRendererQuery } from './__generated__/CustomsMessagingRendererQuery.graphql';
import CustomsMessagingBody from './CustomsMessagingBody';

export type CustomsMessagingRendererProps = {
    userId?: string | null;
    itemId?: string | null;
    shippingAddressId?: string | undefined;
    environment: Environment;
    currency?: string | undefined;
    isAuction?: boolean | undefined;
    wrapperClass?: string;
    messageClass?: string;
};

const query = graphql`
    query CustomsMessagingRendererQuery(
        $userId: String
        $itemId: String
        $shippingAddressId: String
    ) {
        viewer {
            ...CustomsMessagingBody_viewer
        }
    }
`;

const CustomsMessagingRenderer: FC<CustomsMessagingRendererProps> = ({
    userId = '',
    itemId,
    shippingAddressId = null,
    currency = '',
    isAuction = false,
    wrapperClass,
    messageClass,
}) => {
    const { viewer } = useLazyLoadQuery<CustomsMessagingRendererQuery>(query, {
        userId,
        itemId,
        shippingAddressId,
    });

    {
        return (
            <CustomsMessagingBody
                viewer={viewer}
                currency={currency}
                isAuction={isAuction}
                wrapperClass={wrapperClass}
                messageClass={messageClass}
            />
        );
    }
};

export default CustomsMessagingRenderer;
